import { createApp } from 'vue';
import stickerSignup from '../../../vue/forms/sticker-signup.vue';

if (document.getElementById('vue-sticker-signup')) {
  createApp(stickerSignup).mount(
    '#vue-sticker-signup'
  );
}
